import styled from "styled-components";
import Avatar from "../../common/components/Avatar";
import {
  getHeading5BoldTypography,
  getHeading6BoldTypography,
  getParagraph14BoldTypography,
} from "../../common/Typography";
import { getParagraph12RegularTypography } from "../../common/Typography/Paragraph12";
import Button from "../../common/components/Buttons/Button";
import { getFlexCenter, getHorizontalGap } from "../../common/styles";
import Icon from "../../common/components/Icon/Icon";
import { getParagraph16RegularTypography } from "../../common/Typography/Paragraph16";
import StaticLink from "../../common/components/StaticLink/StaticLink";
import ButtonOutlined from "../../common/components/Buttons/ButtonOutlined";

export const Root = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: 39px;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobileL}) {
    padding-bottom: 32px;
  }
`;

export const ContentWrapper = styled.div`
  ${getFlexCenter};
`;

export const Content = styled.div`
  position: relative;
  display: flex;
  flex: 1;
  max-width: 1200px;
  padding: 0 32px;

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    flex-direction: column;
    padding: 20px;
  }
`;

export const EditProfileButtonMobile = styled.div`
  width: 100%;
  margin-top: 12px;
  display: flex;
  ${getHorizontalGap("12px")};

  & > * {
    flex: 1;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    display: none;
  }
`;

export const EditProfileButtonDesktop = styled.div`
  position: absolute;
  right: 32px;
  top: -70px;
  display: flex;
  ${getHorizontalGap("12px")};

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    display: none;
  }
`;

export const LightButtonOutlined = styled(ButtonOutlined)`
  border-color: ${({ theme }) => theme.lightBorderColor};
`;

export const LeftContent = styled.div``;

export const RightContent = styled.div`
  position: relative;
  flex: 1;

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    max-width: 100%;
    width: 100%;
  }
`;

export const AboutWrapper = styled.div`
  margin: 67px 0 28px 0;

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    margin: 32px 0;
  }
`;

export const AboutEmpty = styled.div`
  ${getFlexCenter};
  flex-direction: column;
  padding: 0 32px;
`;

export const AboutEmptyHeader = styled.p`
  ${getHeading5BoldTypography};
  color: ${(props) => props.theme.primaryColor};
  margin-bottom: 4px;
  text-align: center;
`;

export const AboutEmptyDescription = styled.p`
  ${getParagraph16RegularTypography};
  color: ${(props) => props.theme.primaryColor};
  margin-bottom: 12px;
  text-align: center;
`;

export const SectionsWrapper = styled.div`
  padding-top: 32px;
`;

export const StickySection = styled.div<{ $isEditMode?: boolean }>`
  position: ${({ $isEditMode }) => ($isEditMode ? "relative" : "sticky")};
  top: ${({ $isEditMode }) => ($isEditMode ? "0" : "142px")};
  margin: -100px 64px 0 0;

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    position: relative;
    top: 0;
    margin: -64px auto 0 auto;
    width: 100%;
`;

export const ProfileCard = styled.div`
  background-color: ${(props) => props.theme.backgroundColor};
  border-radius: ${(props) => props.theme.borderRadius.lg};
  width: 256px;
  padding: 32px;

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    width: 100%;
`;

export const ThemePanel = styled(ProfileCard)`
  margin-top: 16px;
`;

export const ProfileImageWrapper = styled.div`
  width: 80px;
  height: 80px;
  margin-bottom: 24px;
`;
export const ProfileAvatar = styled(Avatar)`
  object-fit: cover;
  width: 100%;
  height: 100%;
`;
export const Username = styled.h6`
  ${getHeading6BoldTypography};
  color: ${(props) => props.theme.primaryColor};
  margin-bottom: 6px;
  max-width: 200px;

  &:before {
    content: "@";
  }

  &:empty {
    background: ${(props) => props.theme.lightBackgroundColor};
    height: 22px;
    &:before {
      content: "";
    }
  }
`;
export const Followers = styled.div`
  display: flex;
  justify-content: space-between;
  padding-bottom: 35px;
  border-bottom: 1px solid ${(props) => props.theme.borderColor};
  margin-bottom: 35px;
  margin-top: 18px;
`;
export const FollowersInfo = styled.div`
  cursor: pointer;
  display: flex;
  ${getHorizontalGap("14px")};
`;

export const FollowButton = styled(Button)`
  && {
    padding: 0 8px;
  }
`;
export const PrimaryText = styled.p`
  ${getParagraph14BoldTypography};
  color: ${(props) => props.theme.primaryColor};
`;

export const SecondaryText = styled.p`
  color: ${(props) => props.theme.primaryColor};
  ${getParagraph12RegularTypography};
  opacity: 0.7;
`;

const socialIconSize = 22;

export const SocialLinks = styled.div`
  margin-top: 35px;
  display: flex;
  justify-content: space-between;
  height: ${socialIconSize}px;
  flex-wrap: wrap;
`;

export const SocialIconLink = styled(StaticLink)`
  height: ${socialIconSize}px;
  width: ${socialIconSize}px;
`;

export const SocialIcon = styled(Icon)`
  opacity: 0.7;
  cursor: pointer;
  height: ${socialIconSize}px;
  width: ${socialIconSize}px;
`;
